/* @ngInject */
function commentReactionsService (CONSTANTS, ConnectorWebService, Utils) {
  const service = {
    getCommentReactionsById,
    createCommentReaction,
    removeCommentReaction
  }
  return service

  /**
     * Gets the reactions for a comment
     * @param {string} commentId - The ID of the comment
     * @param {string} type - The type of comment ('asset' or 'task')
     * @returns {Promise} - A promise that resolves with the comment reactions
     */
  function getCommentReactionsById (commentId, type) {
    let constantUrl = null
    const constantUrls = {
      asset: CONSTANTS.URL_ASSET_COMMENTS_REACTIONS_GET,
      task: CONSTANTS.URL_TASK_COMMENTS_REACTIONS_GET,
      internal_approval: CONSTANTS.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS_GET,
      art_approval: CONSTANTS.URL_ART_APPROVAL_COMMENTS_REACTIONS_GET
    }

    if (constantUrls[type]) constantUrl = constantUrls[type]
    else throw new Error(`Invalid type: ${type}. Expected 'asset' or 'task'.`)

    const url = Utils.fnReplaceStringParams(constantUrl, [commentId])
    return ConnectorWebService.get(url)
  }

  /**
     * Create a reaction for a comment
     * @param {string} commentId - The ID of the comment
     * @param {object} payload - The reaction data to create
     * @param {string} type - The type of comment ('asset' or 'task')
     * @returns {Promise} - A promise that resolves when the reaction is created
     */
  function createCommentReaction (commentId, payload = {}, type) {
    let constantUrl = null
    const constantUrls = {
      asset: CONSTANTS.URL_ASSET_COMMENTS_REACTIONS_ID,
      task: CONSTANTS.URL_TASK_COMMENTS_REACTIONS_ID,
      internal_approval: CONSTANTS.URL_INTERNAL_APPROVAL_COMMENTS_REACTIONS_ID,
      art_approval: CONSTANTS.URL_ART_APPROVAL_COMMENTS_REACTIONS_ID
    }

    if (constantUrls[type]) constantUrl = constantUrls[type]
    else throw new Error(`Invalid type: ${type}. Expected 'asset' or 'task'.`)

    const url = Utils.fnReplaceStringParams(constantUrl, [commentId])
    return ConnectorWebService.post(url, payload)
  }

  /**
     * Remove a reaction from a comment
     * @param {string} commentId - The ID of the comment
     * @param {string} reactionId - The ID of the reaction to remove
     * @param {string} type - The type of comment ('asset' or 'task')
     * @returns {Promise} - A promise that resolves when the reaction is removed
     */
  function removeCommentReaction (commentId, reactionId, type) {
    let constantUrl = null
    const constantUrls = {
      asset: CONSTANTS.URL_ASSET_COMMENTS_REACTIONS_DELETE,
      task: CONSTANTS.URL_TASK_COMMENTS_REACTIONS_DELETE,
      art_approval: CONSTANTS.URL_ART_APPROVAL_COMMENTS_REACTIONS_DELETE
    }

    if (constantUrls[type]) constantUrl = constantUrls[type]
    else throw new Error(`Invalid type: ${type}. Expected 'asset' or 'task'.`)

    const url = Utils.fnReplaceStringParams(constantUrl, [commentId, reactionId])
    return ConnectorWebService.fnDelete(url)
  }
}

export { commentReactionsService }
